"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewerRoleChangePayloadSchema = exports.ReviewerRoleDomainEventType = exports.PipelinePhase = exports.BuildDomainEventType = exports.DomainEventSubjectType = void 0;
exports.isPipelinePhase = isPipelinePhase;
const z = require("zod");
const reviewer_role_1 = require("../Auth/reviewer-role");
var DomainEventSubjectType;
(function (DomainEventSubjectType) {
    DomainEventSubjectType["Build"] = "build";
    DomainEventSubjectType["User"] = "user";
})(DomainEventSubjectType || (exports.DomainEventSubjectType = DomainEventSubjectType = {}));
var BuildDomainEventType;
(function (BuildDomainEventType) {
    BuildDomainEventType["StatusTransitioned"] = "build.status_transitioned";
    BuildDomainEventType["StatusForced"] = "build.status_forced";
    BuildDomainEventType["AutomationModeChanged"] = "build.automation_mode_changed";
    BuildDomainEventType["IngestionEnrichmentCompleted"] = "build.ingestion_enrichment_completed";
    BuildDomainEventType["MergeEnrichmentCompleted"] = "build.merge_enrichment_completed";
    BuildDomainEventType["ProcessingRestarted"] = "build.processing_restarted";
    BuildDomainEventType["AnalysisDispatchClaimed"] = "build.analysis_dispatch_claimed";
    BuildDomainEventType["AnalysisDispatchReleased"] = "build.analysis_dispatch_released";
    BuildDomainEventType["StatusMessageSet"] = "build.status_message_set";
    BuildDomainEventType["AnalysisSucceededAwaitingCompletion"] = "build.analysis_succeeded_awaiting_completion";
    BuildDomainEventType["AnalysisStarted"] = "build.analysis_started";
    BuildDomainEventType["AnalysisFinished"] = "build.analysis_finished";
    BuildDomainEventType["PipelinePhaseCompleted"] = "build.pipeline_phase_completed";
    BuildDomainEventType["OpsActionTaken"] = "build.ops_action_taken";
    BuildDomainEventType["NetlistGateArmed"] = "build.netlist_gate_armed";
    BuildDomainEventType["NetlistCleared"] = "build.netlist_cleared";
})(BuildDomainEventType || (exports.BuildDomainEventType = BuildDomainEventType = {}));
var PipelinePhase;
(function (PipelinePhase) {
    PipelinePhase["ModuleResolution"] = "module_resolution";
    PipelinePhase["PackageUnderstanding"] = "package_understanding";
    PipelinePhase["AutomapSignals"] = "automap_signals";
    PipelinePhase["AutoreviewResolutions"] = "autoreview_resolutions";
})(PipelinePhase || (exports.PipelinePhase = PipelinePhase = {}));
function isPipelinePhase(value) {
    return Object.values(PipelinePhase).includes(value);
}
var ReviewerRoleDomainEventType;
(function (ReviewerRoleDomainEventType) {
    ReviewerRoleDomainEventType["Granted"] = "user.reviewer_role_granted";
    ReviewerRoleDomainEventType["Revoked"] = "user.reviewer_role_revoked";
})(ReviewerRoleDomainEventType || (exports.ReviewerRoleDomainEventType = ReviewerRoleDomainEventType = {}));
exports.ReviewerRoleChangePayloadSchema = z.object({
    previousRole: reviewer_role_1.ReviewerRoleSchema.nullable(),
    role: reviewer_role_1.ReviewerRoleSchema.nullable(),
});
//# sourceMappingURL=domain-events.js.map